import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, rydeColors } from "@ryde/theme";

export const MapStationInfoPopupStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "map-station-info-container",
})`
  width: 188px;
  padding: 0px;

  .station-info-header {
    text-align: start;
    color: ${blueGreyMui._500};
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid ${rydeColors.softGray};
    margin-bottom: 5px;
    padding-bottom: 5px;
  }

  .content {
    padding: 10px 0px;
    max-height: 135px;
    overflow: auto;
    scrollbar-width: thin;

    .passenger-row {
      display: flex;
      align-items: center;
      gap: 10px;
      position: relative;
    }

    .passenger-row:not(:last-child) {
      margin-bottom: 15px;
    }

    .has-dog {
      position: absolute;
      inset-inline-end: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;
